import { render, staticRenderFns } from "./DiscountAdvantagesPopin.vue?vue&type=template&id=443c5980&scoped=true"
import script from "./DiscountAdvantagesPopin.vue?vue&type=script&lang=js"
export * from "./DiscountAdvantagesPopin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443c5980",
  null
  
)

export default component.exports